import { FC, RefObject, ChangeEvent } from 'react';
import { Avatar } from '@components/atoms/Avatar';

type AvatarSectionProps = {
  imageSrc: string | null;
  displayText?: string;
  onOpenFileDialog: () => void;
  fileInputRef: RefObject<HTMLInputElement>;
  onFileChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

export const AvatarSection: FC<AvatarSectionProps> = ({
  imageSrc,
  displayText,
  onOpenFileDialog,
  fileInputRef,
  onFileChange,
}) => {
  return (
    <div
      onClick={onOpenFileDialog}
      className="flex items-center gap-8 mt-12 cursor-pointer ">
      <Avatar size="3xl" src={imageSrc || ''} text={displayText} />
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        className="hidden"
        onChange={onFileChange}
      />
    </div>
  );
};

export default AvatarSection;
